<script setup>
import TextInput from '@app/components/TextInput.vue';
import { onMounted, watch, ref } from 'vue';
import ModalShow from '@app/components/ModalShow.vue';
import { useRoute, useRouter } from 'vue-router';
import Icon from '@/components/Icon.vue';
import api, { baseURL } from '@/libs/api.js';

const showModalImage = ref(false);
const data = ref(null);
const imageGetPathFullsize = ref(null);
const comments = ref([]);
const id = ref(null);
const route = useRoute();

const router = useRouter();

const form = ref({
    comment: ''
});

onMounted(() => {
    getData();
})

const getData = () => {
    if(route?.params?.id > 0) {
        api.get(`app/feedback/${route.params.id}/show`)
            .then(response => {
                data.value = response.data.data
                getComment();
            });
    }
}

const errors = ref({});

const close = () => {
    router.push({name: 'feedback'});
};

const getComment = () => {
    api.get('app/comment-task/' + route?.params?.id)
        .then(response => {
            comments.value = response.data.data;
        })
}

const postComment = () => {
    form.value.comment = form.value.comment.trim();
    if (form.value.comment === '') {
        errors.value.comment = 'Vui lòng nhập nội dung bình luận.';
        return;
    }
    errors.value.comment = '';
    api.post('app/comment-task/' + route.params.id, form.value)
        .then(response => {
            getComment();
            form.value.comment = '';
        })
        .catch(error => {
            console.error(error);
        });
};

const showImg = (value) => {
    showModalImage.value = true;
    imageGetPathFullsize.value = value;
};

const handleCallBack = () => {
    showModalImage.value = false;
};
const downloadImage = () => {
    const link = document.createElement('a');
    link.href = `${baseURL}${imageGetPathFullsize.value}`;
    link.setAttribute('download', 'downloaded_image.jpg');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

</script>

<template>
    <template v-if="data">
        <ModalShow :show="true" title="Chi tiết phản ánh" @call-back="close">
            <div class="w-full pt-4 px-6">
                <p class="text-xl font-bold ">
                    {{ data.title }}
                </p>
            </div>
            <div class="w-full px-6 pt-4">
                <p class="text-gray-400 font-bold">Thời gian</p>
                <div class="flex justify-center items-center">
                    <p class="w-full text-xs">
                        {{ data.issue_date }}
                    </p>
                    <div class="w-full">
                        <div class="w-max rounded px-3 py-[1px] text-xs font-bold"
                            :style="`color: ${data.status.color}; background-color: ${data.status.color}14;`">
                            {{ data.status ? data.status.name : '' }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-full px-6 pt-4">
                <p class="text-gray-400 font-bold">Mô tả</p>
                <p class="">
                    {{ data.description }}
                </p>
            </div>
            <div class="w-full pt-4 px-6">
                <p class="font-semibold">
                    Hình ảnh (1/5)
                </p>
                <div class="w-full flex flex-wrap gap-2 pt-1">
                    <div v-for="(item, index) in data.pictures" :key="index" @click="showImg(item.fullsize)"
                        class="w-20 h-20 bg-gray-100 rounded border flex flex-col justify-center items-center relative">
                        <img :src="baseURL+item.fullsize" :alt="item.filename" class="object-contain max-h-4/5 w-auto">
                    </div>
                </div>
            </div>
            <div class="w-full pt-4 px-6">
                <label for="comment" class="font-semibold">
                    Bình luận
                </label>
                <textarea v-model="form.comment" type="text" id="comment" rows="4"
                    class="w-full mt-1 border border-gray-300 rounded-md px-4 py-3 focus:border-main focus:ring-main"
                    placeholder="Thêm cập nhật, trao đổi..."></textarea>
                <p v-if="errors && errors.comment" class="text-red-600 text-sm mt-1 px-4">
                    {{ errors.comment }}
                </p>
            </div>
            <div class="w-full py-4 flex justify-center items-center px-6">
                <button @click.prevent="postComment" type="button" class="w-full font-bold text-center py-4 bg-main text-white rounded shadow">
                    Bình luận
                </button>
            </div>
            <div v-if="comments.length > 0" class="w-full px-6 pb-4">
                <div v-for="(item, index) in comments" :key="index"
                    class="w-full flex justify-between items-start gap-4 mb-4 animation_up">
                    <div class="w-12 h-12 flex-none rounded-full bg-white border">
                        <div v-if="item.user && item.user.picture"
                            class="w-full h-full bg-white rounded-full overflow-hidden">
                            <img :src="baseURL+item.user?.picture.fullsize" :alt="item.user.picture.filename"
                                class="object-cover h-full w-full">
                        </div>
                        <div v-else
                            class="w-full h-full flex justify-center items-center bg-amber-600 rounded-full overflow-hidden">
                            <svg class="w-8 h-8 fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="-42 0 512 512.002">
                                <path
                                    d="m210.351562 246.632812c33.882813 0 63.222657-12.152343 87.195313-36.128906 23.972656-23.972656 36.125-53.304687 36.125-87.191406 0-33.875-12.152344-63.210938-36.128906-87.191406-23.976563-23.96875-53.3125-36.121094-87.191407-36.121094-33.886718 0-63.21875 12.152344-87.191406 36.125s-36.128906 53.308594-36.128906 87.1875c0 33.886719 12.15625 63.222656 36.132812 87.195312 23.976563 23.96875 53.3125 36.125 87.1875 36.125zm0 0" />
                                <path
                                    d="m426.128906 393.703125c-.691406-9.976563-2.089844-20.859375-4.148437-32.351563-2.078125-11.578124-4.753907-22.523437-7.957031-32.527343-3.308594-10.339844-7.808594-20.550781-13.371094-30.335938-5.773438-10.15625-12.554688-19-20.164063-26.277343-7.957031-7.613282-17.699219-13.734376-28.964843-18.199219-11.226563-4.441407-23.667969-6.691407-36.976563-6.691407-5.226563 0-10.28125 2.144532-20.042969 8.5-6.007812 3.917969-13.035156 8.449219-20.878906 13.460938-6.707031 4.273438-15.792969 8.277344-27.015625 11.902344-10.949219 3.542968-22.066406 5.339844-33.039063 5.339844-10.972656 0-22.085937-1.796876-33.046874-5.339844-11.210938-3.621094-20.296876-7.625-26.996094-11.898438-7.769532-4.964844-14.800782-9.496094-20.898438-13.46875-9.75-6.355468-14.808594-8.5-20.035156-8.5-13.3125 0-25.75 2.253906-36.972656 6.699219-11.257813 4.457031-21.003906 10.578125-28.96875 18.199219-7.605469 7.28125-14.390625 16.121094-20.15625 26.273437-5.558594 9.785157-10.058594 19.992188-13.371094 30.339844-3.199219 10.003906-5.875 20.945313-7.953125 32.523437-2.058594 11.476563-3.457031 22.363282-4.148437 32.363282-.679688 9.796875-1.023438 19.964844-1.023438 30.234375 0 26.726562 8.496094 48.363281 25.25 64.320312 16.546875 15.746094 38.441406 23.734375 65.066406 23.734375h246.53125c26.625 0 48.511719-7.984375 65.0625-23.734375 16.757813-15.945312 25.253906-37.585937 25.253906-64.324219-.003906-10.316406-.351562-20.492187-1.035156-30.242187zm0 0" />
                            </svg>
                        </div>
                    </div>
                    <div class="w-full">
                        <div class="grid grid-cols-2 justify-between items-center gap-1">
                            <p class="font-bold">
                                {{ item.user ? item.user.name : 'NaN' }}
                            </p>
                            <p class="text-xs text-right">
                                {{ item.created_at }}
                            </p>
                        </div>
                        <p>
                            {{ item.comment }}
                        </p>
                    </div>
                </div>
            </div>
        </ModalShow>
        <transition name="slide-up">
            <div v-if="showModalImage" class="absolute top-0 left-0 z-50 w-full h-screen bg-white">
                <div class="w-full h-full relative">
                    <div class="w-full h-full bg-black overflow-auto flex justify-center items-center">
                        <img :src="baseURL+imageGetPathFullsize" alt="image">
                    </div>
                    <div class="w-full h-auto absolute z-10 bottom-0 bg-white px-6">
                        <div class="w-full h-auto flex justify-center items-center">
                            <div @click="handleCallBack"
                                class="w-full h-auto flex justify-center items-center flex-col py-6">
                                <Icon name="close" class="w-8 h-8 border rounded fill-gray-500 p-2 bg-white" />
                                <p class="mt-1 text-sm">Đóng</p>
                            </div>
                            <a :href="baseURL+imageGetPathFullsize" :download="'downloaded-image.jpg'"
                                class="w-full h-auto flex justify-center items-center flex-col py-6">
                                <Icon name="download" class="w-8 h-8 fill-gray-500 bg-white" />
                                <p class="mt-1 text-sm">Tải xuống</p>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </template>
</template>